export default "__VITE_ASSET__B7YLW9m6__"